module.exports = __webpack_public_path__ + "79d5995426129878cd4af2598dbd7b53.png";


//////////////////
// WEBPACK FOOTER
// ../images/admin/campaign_wrap_up/locations/rhodeisland.png
// module id = 3265
// module chunks = 69